/** When your routing table is too long, you can split it into small modules **/

import Layout from "@/layout";
import Nested from "@/layout/nested";

const adminRouter = [
  {
    path: "/customer-service",
    component: Layout,
    redirect: "/customer-service/messenger",
    name: "CustomerService",
    meta: {
      title: "Customer Service",
      icon: "iconfont icon-message",
    },
    children: [
      {
        name: "MessengerConversations",
        path: "messenger",
        component: () => import("@/views/pages/messenger/conversations/index"),
        meta: {
          title: "Messenger",
          icon: "iconfont icon-message",
        },
      },
      {
        name: "SourcingLookup",
        path: "sourcing-lookup",
        component: () => import("@/views/pages/sourcing/dewu-lookup/index"),
        meta: {
          title: "Sourcing Lookup",
          icon: "iconfont icon-search",
        },
      },
      {
        name: "SourcingDevices",
        path: "sourcing-devices",
        component: () => import("@/views/pages/sourcing/devices/index"),
        meta: {
          title: "Sourcing Devices",
          icon: "iconfont icon-mobile",
        },
      },
      {
        name: "SourcingQuotes",
        path: "quotes",
        component: () => import("@/views/pages/sourcing/quotes/index"),
        meta: {
          title: "Sourcing Quotes",
          icon: "iconfont icon-money",
        },
      },
    ],
  },
  {
    path: "/users",
    component: Layout,
    redirect: "/users/users",
    meta: {
      title: "Users Management",
      icon: "iconfont icon-username",
    },
    children: [
      {
        name: "Users",
        path: "users",
        component: () => import("@/views/pages/user/index"),
        meta: {
          title: "Users Management",
          icon: "iconfont icon-username",
        },
      },
      {
        name: "LevelConfig",
        path: "level-config",
        component: () => import("@/views/pages/level-config/index"),
        meta: {
          title: "Level Setting",
          icon: "iconfont icon-username",
        },
      },
      {
        name: "VipSeller",
        path: "vip-seller",
        component: () => import("@/views/pages/vip-seller/index"),
        meta: {
          title: "VIP Seller",
          icon: "iconfont icon-username",
        },
      },
      {
        name: "VipBuyer",
        path: "vip-buyer",
        component: () => import("@/views/pages/vip-buyer/index"),
        meta: {
          title: "VIP Buyer",
          icon: "iconfont icon-username",
        },
      },
    ],
  },
  {
    path: "/mall",
    component: Layout,
    redirect: "/mall/seller-order",
    name: "pre-order",
    meta: {
      title: "Market Management",
      icon: "iconfont icon-category",
    },
    children: [
      {
        name: "ProductCategory",
        path: "product-category",
        component: () => import("@/views/pages/mall/product-category/index"),
        meta: {
          title: "Products Category",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "Product",
        path: "product",
        component: () => import("@/views/pages/mall/product/index"),
        meta: {
          title: "Product Management",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "RecommendForYou",
        path: "recommend-for-you",
        component: () => import("@/views/pages/mall/recommend-for-you/index"),
        meta: {
          title: "Recommend for you",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "SellerOrder",
        path: "seller-order",
        component: () => import("@/views/pages/mall/seller-order/index"),
        meta: {
          title: "Sellers Orders",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "BuyerOrder",
        path: "buyer-order",
        component: () => import("@/views/pages/mall/buyer-order/index"),
        meta: {
          title: "Buyers Orders",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "PaymentOrder",
        path: "payment-order",
        component: () => import("@/views/pages/payment-order/index"),
        meta: {
          title: "Payments Records",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "Search",
        path: "/search",
        component: Nested,
        meta: {
          title: "Search Management",
          icon: "iconfont icon-category",
        },
        children: [
          {
            name: "SearchAutocomplete",
            path: "autocomplete",
            component: () => import("@/views/pages/search-autocomplete/index"),
            meta: {
              title: "Auto Complete",
              icon: "iconfont icon-category",
            },
          },
          {
            name: "SearchRecommendWord",
            path: "recommend-word",
            component: () => import("@/views/pages/search-recommend-word/index"),
            meta: {
              title: "Recommend Word",
              icon: "iconfont icon-category",
            },
          },
          {
            name: "SearchTrendsForYou",
            path: "trends-for-you",
            component: () => import("@/views/pages/search-trends-for-you/index"),
            meta: {
              title: "Trends For You",
              icon: "iconfont icon-category",
            },
          },
        ],
      },
      {
        name: "Coupon",
        path: "coupon",
        component: () => import("@/views/pages/mall/coupon/index"),
        meta: {
          title: "Vouchers",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "UserCoupon",
        path: "user-coupon",
        component: () => import("@/views/pages/mall/user-coupon/index"),
        meta: {
          title: "User's Vouchers",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "ImportTask",
        path: "import-task",
        component: () => import("@/views/pages/import-task/index"),
        meta: {
          title: "Import Missions",
          icon: "iconfont icon-category",
        },
      },
    ],
  },
  // {
  //   path: "/pre-order",
  //   component: Layout,
  //   redirect: "/pre-order/goods-category",
  //   name: "pre-order",
  //   meta: {
  //     title: "预售订单",
  //     icon: "iconfont icon-category",
  //   },
  //   children: [
  //     {
  //       name: "goods-category",
  //       path: "goods-category",
  //       component: () => import("@/views/pages/goods-category/index"),
  //       meta: {
  //         title: "商品分类",
  //         icon: "iconfont icon-category",
  //       },
  //     },
  //     {
  //       name: "goods-config",
  //       path: "goods-config",
  //       component: () => import("@/views/pages/goods-config/index"),
  //       meta: {
  //         title: "商品管理",
  //         icon: "iconfont icon-goods",
  //       },
  //     },
  //     {
  //       name: "pre-order",
  //       path: "pre-order",
  //       component: () => import("@/views/pages/pre-order/index"),
  //       meta: {
  //         title: "订单管理",
  //         icon: "iconfont icon-order",
  //       },
  //     },
  //   ],
  // },

  {
    path: "/community",
    component: Layout,
    redirect: "/community/topics",
    name: "content",
    meta: {
      title: "内容管理",
      icon: "iconfont icon-category",
    },
    children: [
      {
        name: "Topics",
        path: "topics",
        component: () => import("@/views/pages/topics/index"),
        meta: {
          title: "帖子管理",
          icon: "iconfont icon-topic",
        },
      },
      {
        name: "News",
        path: "news",
        component: () => import("@/views/pages/articles/index"),
        meta: {
          title: "News",
          icon: "iconfont icon-article",
        },
      },
      {
        name: "PublishGoodsShow",
        path: "publish-goods-show",
        component: () => import("@/views/pages/topics/publish-goods-show"),
        meta: {
          title: "发表买家秀",
          icon: "iconfont icon-topic",
        },
      },
      {
        name: "nodes",
        path: "nodes",
        component: () => import("@/views/pages/topics/nodes"),
        meta: {
          title: "帖子分类",
          icon: "iconfont icon-tag",
        },
      },
      {
        name: "tags",
        path: "tags",
        component: () => import("@/views/pages/tags/index"),
        meta: {
          title: "帖子标签",
          icon: "iconfont icon-tags",
        },
      },
    ],
  },

  {
    path: "/legit-check",
    component: Layout,
    name: "content",
    meta: {
      title: "Legit-Check",
      icon: "iconfont icon-category",
    },
    children: [
      {
        name: "LegitCheck",
        path: "legit-check",
        component: () => import("@/views/pages/legit-check/topic"),
        meta: {
          title: "Legit-Check",
          icon: "iconfont icon-appraise",
        },
      },
      {
        name: "鉴定分类",
        path: "legit-check-tag",
        component: () => import("@/views/pages/legit-check/tag/index"),
        meta: {
          title: "鉴定分类",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "LegitCheckt图片配置",
        path: "legit-check-image-type",
        component: () => import("@/views/pages/legit-check/appraise-image-type/index"),
        meta: {
          title: "LegitCheckt图片配置",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "LegitCheckOpinion",
        path: "legit-check-opinion",
        component: () => import("@/views/pages/legit-check/legit-check-opinion/index"),
        meta: {
          title: "鉴定意见",
          icon: "iconfont icon-category",
        },
      },
    ],
  },
  {
    path: "/operation",
    component: Layout,
    redirect: "/operation/tasks",
    name: "operation",
    meta: {
      title: "运营管理",
      icon: "iconfont icon-category",
    },
    children: [
      {
        name: "Banner",
        path: "banner",
        component: () => import("@/views/pages/mall/banner/index"),
        meta: {
          title: "Banner管理",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "HomeBoard",
        path: "home-board",
        component: () => import("@/views/pages/mall/home-board/index"),
        meta: {
          title: "首页展示管理",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "Tasks",
        path: "tasks",
        component: () => import("@/views/pages/task-config/index"),
        meta: {
          title: "任务系统",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "qa",
        path: "qa",
        component: () => import("@/views/pages/qa/index"),
        meta: {
          title: "Q&A",
          icon: "iconfont icon-faq",
        },
      },
      {
        name: "feedback",
        path: "feedback",
        component: () => import("@/views/pages/feedback/index"),
        meta: {
          title: "工单",
          icon: "iconfont icon-gongdan",
        },
      },
      {
        name: "report",
        path: "report",
        component: () => import("@/views/pages/report/index"),
        meta: {
          title: "举报",
          icon: "iconfont icon-jubao",
        },
      },
      {
        name: "lucky-draw-prize",
        path: "lucky-draw-prize",
        component: () => import("@/views/pages/lucky-draw-prize/index"),
        meta: {
          title: "抽奖配置",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "goods",
        path: "goods",
        component: () => import("@/views/pages/goods/index"),
        meta: {
          title: "抽奖商品",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "user-goods",
        path: "user-goods",
        component: () => import("@/views/pages/user-goods/index"),
        meta: {
          title: "抽奖记录",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "AutoTask",
        path: "auto-task",
        component: () => import("@/views/pages/auto-task/index"),
        meta: {
          title: "自动任务",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "EmailSend",
        path: "email-send",
        component: () => import("@/views/pages/email-send/index"),
        meta: {
          title: "邮件发送",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "ActConfig",
        path: "act-config",
        component: () => import("@/views/pages/act-config/index"),
        meta: {
          title: "活动管理",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "ActInvite",
        path: "act-invite",
        component: () => import("@/views/pages/act-invite/index"),
        meta: {
          title: "Events joiners",
          icon: "iconfont icon-category",
        },
      },
    ],
  },

  {
    path: "/stat",
    component: Layout,
    redirect: "/stat/topics",
    name: "stat",
    meta: {
      title: "统计报表",
      icon: "iconfont icon-category",
    },
    children: [
      {
        name: "StatTopics",
        path: "topics",
        component: () => import("@/views/pages/stat/topics"),
        meta: {
          title: "帖子统计",
          icon: "iconfont icon-category",
        },
      },
      {
        name: "StatUsers",
        path: "users",
        component: () => import("@/views/pages/stat/users"),
        meta: {
          title: "用户统计",
          icon: "iconfont icon-category",
        },
      },
    ],
  },

  {
    path: "/system",
    component: Layout,
    redirect: "/system/dict",
    name: "system",
    meta: {
      title: "系统",
      icon: "iconfont icon-setting",
    },
    children: [
      {
        name: "Dict",
        path: "dict",
        component: () => import("@/views/pages/dict/index"),
        meta: {
          title: "字典表",
          icon: "iconfont icon-setting",
        },
      },
      {
        name: "Settings",
        path: "settings",
        component: () => import("@/views/pages/settings/index"),
        meta: {
          title: "系统设置",
          icon: "iconfont icon-setting",
        },
      },
    ],
  },
];
export default adminRouter;
